"use client"
import React, { useState } from 'react';
import useFetch from '@/app/useFetch'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
const Faq = () => {
    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    //  const [page, setPage] = useState(1);
    const { data: list, loading, error } = useFetch(
        "/website/general-information-faq",
        // { page, limit: 5 }, // pass page & limit here
        []
    );



    return (
        <>
            <section className='mt-40'>
                <div className='faq-accordion'>
                    <Accordion open={open} toggle={toggle}>
                        {list?.length > 0 ? (
                            <>
                                {list.map((item, index) => (
                                    <>
                                        <AccordionItem>
                                            <AccordionHeader targetId={item.id}>Q &nbsp; &nbsp;{item?.name}</AccordionHeader>
                                            <AccordionBody accordionId={item.id}>
                                                {item.details}
                                            </AccordionBody>
                                        </AccordionItem>
                                    </>
                                ))}
                            </>
                        ) : null}
                    </Accordion>
                </div>
            </section>

        </>
    )
}

export default Faq
